/* eslint-disable no-useless-catch */
import Service from "../../service";

const WIDGET_BASE = `finance/v1/reporting/widget`;

const toQS = (dateRange) => {
  if (!dateRange?.from || !dateRange?.to) return "";
  const p = new URLSearchParams({
    from: dateRange.from instanceof Date ? dateRange.from.toISOString() : dateRange.from,
    to: dateRange.to instanceof Date ? dateRange.to.toISOString() : dateRange.to,
  });
  return `?${p}`;
};

const ReportingService = {
  getDashboard: async (token) => {
    try {
      return await Service.get(`finance/v1/reporting/dashboard`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetRevenue: async (token, dateRange, filter = {}) => {
    try {
      const params = new URLSearchParams();
      if (dateRange?.from) params.set("from", dateRange.from instanceof Date ? dateRange.from.toISOString() : dateRange.from);
      if (dateRange?.to) params.set("to", dateRange.to instanceof Date ? dateRange.to.toISOString() : dateRange.to);
      if (dateRange?.priorFrom) params.set("priorFrom", dateRange.priorFrom instanceof Date ? dateRange.priorFrom.toISOString() : dateRange.priorFrom);
      if (dateRange?.priorTo) params.set("priorTo", dateRange.priorTo instanceof Date ? dateRange.priorTo.toISOString() : dateRange.priorTo);
      if (filter.ledger?.length) filter.ledger.forEach((id) => params.append("ledger", id));
      if (filter.subLedger?.length) filter.subLedger.forEach((id) => params.append("subLedger", id));
      const qs = params.toString() ? `?${params}` : "";
      return await Service.get(`${WIDGET_BASE}/revenue${qs}`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetOutstandingBalances: async (token, filter = {}) => {
    try {
      const params = new URLSearchParams();
      if (filter.ledger?.length) filter.ledger.forEach((id) => params.append("ledger", id));
      if (filter.subLedger?.length) filter.subLedger.forEach((id) => params.append("subLedger", id));
      if (filter.dateRange?.from) params.set("from", filter.dateRange.from.toISOString());
      if (filter.dateRange?.to) params.set("to", filter.dateRange.to.toISOString());
      const qs = params.toString() ? `?${params}` : "";
      return await Service.get(`${WIDGET_BASE}/outstanding-balances${qs}`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetDonationBox: async (token, dateRange) => {
    try {
      return await Service.get(`${WIDGET_BASE}/donation-box${toQS(dateRange)}`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetMemberCount: async (token, dateRange) => {
    try {
      return await Service.get(`${WIDGET_BASE}/member-count${toQS(dateRange)}`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetYahrzeits: async (token, dateType = "english") => {
    try {
      const res = await Service.get(
        `/accounts/deceased/upcoming?dateType=${dateType}`,
        token
      );
      return { upcoming: res?.upcoming || [] };
    } catch (error) {
      throw error;
    }
  },

  getWidgetEvents: async (token) => {
    try {
      return await Service.get(`${WIDGET_BASE}/events`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetRecentTransactions: async (token, dateRange, filter = {}) => {
    try {
      const params = new URLSearchParams();
      if (dateRange?.from) params.set("from", dateRange.from instanceof Date ? dateRange.from.toISOString() : dateRange.from);
      if (dateRange?.to) params.set("to", dateRange.to instanceof Date ? dateRange.to.toISOString() : dateRange.to);
      if (filter.ledger?.length) filter.ledger.forEach((id) => params.append("ledger", id));
      if (filter.subLedger?.length) filter.subLedger.forEach((id) => params.append("subLedger", id));
      const qs = params.toString() ? `?${params}` : "";
      return await Service.get(`${WIDGET_BASE}/recent-transactions${qs}`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetSchoolEnrollment: async (token) => {
    try {
      return await Service.get(`${WIDGET_BASE}/school-enrollment`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetAlerts: async (token) => {
    try {
      return await Service.get(`${WIDGET_BASE}/alerts`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetDonations: async (token, dateRange) => {
    try {
      return await Service.get(`${WIDGET_BASE}/donations${toQS(dateRange)}`, token);
    } catch (error) {
      throw error;
    }
  },

  getWidgetBirthdays: async (token) => {
    try {
      const res = await Service.get(`/accounts/contact/upcoming/birthdays`, token);
      return { upcoming: res?.upcoming || [] };
    } catch (error) {
      throw error;
    }
  },

  getWidgetAnniversaries: async (token) => {
    try {
      const res = await Service.get(`/accounts/contact/upcoming/anniversaries`, token);
      return { upcoming: res?.upcoming || [] };
    } catch (error) {
      throw error;
    }
  },

  getWidgetFuturePayments: async (token) => {
    try {
      return await Service.get(`${WIDGET_BASE}/future-payments`, token);
    } catch (error) {
      throw error;
    }
  },
};

export default ReportingService;
